import Pusher from "pusher-js";
import _ from "underscore";

import auth from "@/helpers/auth";

let pusher;
let connectedRealtimeChannels = [];

export default {
  instance() {
    const teamId = auth.teamId();
    let authEndpoint = process.env.API_BASE_URL + "pusher/auth";
    if (teamId) authEndpoint += "?team_id=" + teamId;

    if (pusher) {
      pusher.config.authEndpoint = authEndpoint;
      return pusher;
    }

    pusher = new Pusher(process.env.PUSHER_KEY, {
      authEndpoint: authEndpoint,
      auth: {
        headers: { Authorization: "Bearer " + auth.getToken() }
      },
      encrypted: true,
      cluster: "eu"
    });

    return pusher;
  },

  subscribe(channelName, event, callback) {
    const socket = this.instance();
    let channel = socket.channel(channelName);

    if (!channel) {
      channel = socket.subscribe(channelName);
      connectedRealtimeChannels.push(channelName);
    }

    channel.bind(event, callback);
  },

  unsubscribe(channelName) {
    const socket = this.instance();

    const existing = socket.channel(channelName);
    existing.unbind();
    socket.unsubscribe(channelName);
    connectedRealtimeChannels = _.without(connectedRealtimeChannels, channelName);
  },

  unsubscribeAll() {
    _.each(connectedRealtimeChannels, (channelName) => {
      this.unsubscribe(channelName);
    });
  }
};
